import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import styles from "./index.module.css";
import touchPosSlide from "../../../layout/assets/slider/touch_pos.png";
import barcodeScannerSlide from "../../../layout/assets/slider/barcode_scanner.png";
import receiptPrinterSlide from "../../../layout/assets/slider/receipt_printer.png";
import stickerPrinterSlide from "../../../layout/assets/slider/sticker_printer.png";
import monitorSlide from "../../../layout/assets/slider/monitor.png";
import cashDrawerSlide from "../../../layout/assets/slider/cash_drawer.png";
import pcSlide from "../../../layout/assets/slider/pc.png";

const SLIDER_IMAGES = [
  { title: "Touch POS", src: touchPosSlide },
  { title: "Barcode Scanner", src: barcodeScannerSlide },
  { title: "Receipt Printer", src: receiptPrinterSlide },
  { title: "Sticker Printer", src: stickerPrinterSlide },
  { title: "Monitor", src: monitorSlide },
  { title: "Cash Drawer", src: cashDrawerSlide },
  { title: "PC", src: pcSlide },
];

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 0 },
    items: 1,
    slidesToSlide: 1,
  },
};

const TopContainer = () => {
  return (
    <section className={styles.hero}>
      <div className={styles.heroInner}>
        <div className={styles.heroLeft}>
          <h1 className={styles.heroTitle}>
            Reliable POS Hardware
            <br />
            Accessories
          </h1>
          <p className={styles.heroDescription}>
            The hardware behind every smooth transaction. Scanners, printers,
            and displays built to keep your counter fast, professional, and
            always ready.
          </p>
          <div className={styles.heroActions}>
            <a className={styles.heroPrimaryBtn} href="#catalog">
              Explore Products
            </a>
            <a className={styles.heroSecondaryBtn} href="/#info">
              Browse Catalog
            </a>
          </div>
        </div>

        <div className={styles.heroCenter}>
          <div className={styles.heroCarousel}>
            <Carousel
              responsive={responsive}
              infinite
              autoPlay
              autoPlaySpeed={3200}
              swipeable
              draggable
              arrows={false}
              showDots
              pauseOnHover={false}
              containerClass={styles.carouselContainer}
              sliderClass={styles.carouselSlider}
              itemClass={styles.carouselItem}
              dotListClass={styles.carouselDots}
            >
              {SLIDER_IMAGES.map((slide) => (
                <div className={styles.heroSlide} key={slide.title}>
                  <img
                    className={styles.heroImage}
                    src={slide.src}
                    alt={slide.title}
                  />
                </div>
              ))}
            </Carousel>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TopContainer;
